import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from '../../../services/user.service'
import { AdministrationService } from '../../../services/administration.service'
import { MatSnackBar } from '@angular/material';
import { MatSort, MatDialog } from '@angular/material';
import { AddNewFareDialog } from '../../administration/fare-list/dialog.addnewfare';
import { EditFareDialog } from '../../administration/fare-list/dialog.editfare';
import { DatePipe } from '@angular/common'

@Component({
  selector: 'app-fare-list',
  templateUrl: './fare-list.component.html',
  styleUrls: ['./fare-list.component.css']
})
export class FareListComponent implements OnInit, OnDestroy {
  allSub: Subscription[] = [];
  errorMessage: string = '';
  userLevels = [];

  isLoading: boolean = false;
  isCommenceDate: boolean = false;
  isDepartureStation: boolean = false;
  isArrivalStation: boolean = false;
  isStatus: boolean = false;
  searchTypes = [];
  datasource = [];
  departureStations = [];
  arrivalStations = [];
  commenceDates = [];
  statusList = [];
  p: number = 1;
  totalCount: number = 0;
  userName: string = '';
  screenCode: string = '';
  selectedSearchType: number = 0;
  selectedSearchValue: string = '';

  constructor(private administrationService: AdministrationService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private userService: UserService,
    public datepipe: DatePipe) {
    let user = this.userService.getUser();
    this.userName = user.username;
    this.screenCode = user.screenCode;
  }

  ngOnInit() {
    this.isLoading = true;

    let init_sub = this.administrationService.getInitFareList()
      .subscribe(
        (value) => {
          this.isLoading = false;
          if (value.status === 204) {
          } else if (value.status === 200) {
            this.searchTypes = value.body['searchTypeList'];
            this.datasource = value.body['fareList'];
            this.totalCount = value.body['totalRecord'];
            this.departureStations = value.body['departureStationList'];
            this.arrivalStations = value.body['arrivalStationList'];
            this.commenceDates = value.body['commenceDateList'];
            this.statusList = value.body['fareStatusList'];
          } else {
            this.openSnackBar('Error retrieving fare list.', '');
          }
        },
        (error) => {
          this.isLoading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(init_sub);
  }

  nextPage(page: number) {
    this.isLoading = true;
    let searchFareList = {
      PageNumber: page,
      SelectedSearchType: this.selectedSearchType,
      SelectedSearchValue: this.selectedSearchValue
    };

    let init_sub = this.administrationService.getFareList(searchFareList)
      .subscribe(
        (value) => {
          this.isLoading = false;
          if (value.status === 204) {

          } else if (value.status === 200) {
            this.p = page;
            this.datasource = value.body['fareList'];
            this.totalCount = value.body['totalRecord'];
          } else {
            this.openSnackBar('Error retrieving fare list.', '');
          }
        },
        (error) => {
          this.isLoading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(init_sub);
  }

  searchTypeOnChange(e) {
    this.selectedSearchType = e.value;

    switch (e.value) {
      case 1:
        this.selectedSearchValue = '';
        this.isCommenceDate = false;
        this.isDepartureStation = true;
        this.isArrivalStation = false;
        this.isStatus = false;
        break;
      case 2:
        this.selectedSearchValue = '';
        this.isCommenceDate = false;
        this.isDepartureStation = false;
        this.isArrivalStation = true;
        this.isStatus = false;
        break;
      case 3:
        this.selectedSearchValue = '';
        this.isCommenceDate = true;
        this.isDepartureStation = false;
        this.isArrivalStation = false;
        this.isStatus = false;
        break;
      case 4:
        this.selectedSearchValue = '';
        this.isCommenceDate = false;
        this.isDepartureStation = false;
        this.isArrivalStation = false;
        this.isStatus = true;
        break;
      default:
        this.selectedSearchValue = '';
        this.isCommenceDate = false;
        this.isDepartureStation = false;
        this.isArrivalStation = false;
        this.isStatus = false;
        break;
    }
  }

  departureStationOnChange(e) {
    this.selectedSearchValue = e.value;
  }

  arrivalStationOnChange(e) {
    this.selectedSearchValue = e.value;
  }

  commenceDateOnChange(e) {
    this.selectedSearchValue = e.value;
  }

  statusOnChange(e) {
    if (e.value === true) {
      this.selectedSearchValue = '1';
    } else if (e.value === false) {
      this.selectedSearchValue = '0';
    }
  }

  addNewFare() {
    let dialogRef = this.dialog.open(AddNewFareDialog, {
      width: '60%',
      disableClose: true,
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Save successful') {
        this.nextPage(1);
        this.openSnackBar('New fare added.', '');
      }
    });
  }

  editFare(fare: any) {
    let dialogRef = this.dialog.open(EditFareDialog, {
      width: '60%',
      disableClose: true,
      data: {
        DepartureStation: fare.DepartureStation,
        ArrivalStation: fare.ArrivalStation,
        BaseFare: fare.BaseFareAmt.toFixed(2),
        AirPortTax: fare.AirPortTax.toFixed(2),
        FuelSurcharge: fare.FuelSurcharge.toFixed(2),
        PymntAmt: fare.PymntAmt.toFixed(2),
        CommenceDate: this.datepipe.transform(fare.CommenceDate, 'yyyy-MM-dd'),
        Status: fare.Status,
        StatusList: this.statusList
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Edit successful') {
        this.nextPage(1);
        this.openSnackBar('Changes saved.', '');
      }
    });
  }

  searchFareList() {
    this.isLoading = true;
    let searchFareList = {
      PageNumber: 1,
      SelectedSearchType: this.selectedSearchType,
      SelectedSearchValue: this.selectedSearchValue
    };

    let init_sub = this.administrationService.getFareList(searchFareList)
      .subscribe(
        (value) => {
          this.isLoading = false;
          if (value.status === 204) {

          } else if (value.status === 200) {
            this.datasource = value.body['fareList'];
            this.totalCount = value.body['totalRecord'];
          } else {
            this.openSnackBar('Error retrieving fare list.', '');
          }
        },
        (error) => {
          this.isLoading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(init_sub);
  }

  ngOnDestroy() {
    for (let sub of this.allSub) {
      sub.unsubscribe();
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
